import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImac"><Path d="M2 3V12H22V3H2Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 18V14H22V18H15V22H9V18H2ZM11 18V20H13V18H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImac;
